import { PostGroupsType } from '../models/post-editor';
import { SocialProfileWithBoardsAndMentionType } from '../modules/PostEditor/helpers/mapSelectedProfilesValues';
import { TikTokProfileValues } from '../components/socialProfiles/SocialProfileListItem/SocialProfileListItem.view';

export const mapSocialProfilesWithBoardsToPostGroupProfiles = (
  socialProfiles: SocialProfileWithBoardsAndMentionType[],
  formProfiles: Array<string | false>,
  pnBoards: Array<string | null>,
  tikToks: Array<TikTokProfileValues | null>
): PostGroupsType['profiles'] =>
  formProfiles.flatMap((profileId, index) => {
    if (!profileId) {
      return [];
    }
    const mappedProfile = socialProfiles.find(profile => profile.id === profileId);
    if (!mappedProfile) return [];
    const pnBoardId =
      mappedProfile.__typename === 'PinterestSocialProfile' && pnBoards && pnBoards[index] ? pnBoards[index] ?? '' : '';
    const tikTok =
      mappedProfile.__typename === 'TikTokSocialProfile' && tikToks && tikToks[index] ? tikToks[index] : null;
    return {
      __typename: mappedProfile.__typename,
      profileId,
      ...(mappedProfile.__typename === 'PinterestSocialProfile' ? { pnBoardId } : {}),
      ...(mappedProfile.__typename === 'TikTokSocialProfile' && tikTok ? { tikTok } : { tikTok: undefined })
    };
  });
